
<!-- HERO -->
<section class="news-hero">
  <img src="assets/navimage.png" alt="News Banner" />
  <div class="news-hero__overlay">
    <div class="news-hero__content">
      <h1>News & Updates</h1>
      <p>Latest announcements, articles, and insights</p>
    </div>
  </div>
</section>

<!-- CONTENT -->
<section class="news">

  <!-- HEADER -->
  <header class="news__header">
    <div class="news__title">
      <h2>Latest News</h2>
      <span class="subtitle">Stay informed with recent updates</span>
    </div>

    <mat-form-field appearance="outline" class="news__filter">
      <mat-label>Time Range</mat-label>
      <mat-select [(ngModel)]="selNewsRange" (selectionChange)="getNewsList()">
        <mat-option *ngFor="let range of newsrange" [value]="range">
          {{ range.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </header>

  <!-- STATES -->
  <div class="news__state" *ngIf="isLoading">
    <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
    <span>Loading news...</span>
  </div>

  <div class="news__state error" *ngIf="hasError">
    Failed to load news. Please try again.
  </div>

  <!-- FEATURED NEWS -->
  <article class="featured-news" *ngIf="latestNews && !isLoading">
    <div class="featured-news__image">
      <img
        [src]="latestNews.image.fileUUID ? imageBaseUrl + latestNews.image.fileUUID : defaultImg"
        alt="Featured News"
      />
    </div>

    <div class="featured-news__content">
      <div class="featured-news__meta">
        <span class="category">{{ latestNews.category.categoryName }}</span>
        <span class="date">{{ transformDate(latestNews.publicationDate) }}</span>
      </div>

      <h3 class="featured-news__title">
        {{ latestNews.newsTitle }}
      </h3>

      <div class="featured-news__description clamp-4"
           [innerHTML]="latestNews.newsDescp">
      </div>

      <div class="featured-news__actions">
        <button mat-stroked-button color="primary" (click)="goToFullNews(latestNews)">
          Read Full Story
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button mat-icon-button (click)="share()" aria-label="Share">
          <mat-icon>share</mat-icon>
        </button>
      </div>
    </div>
  </article>

  <!-- NEWS GRID -->
  <section class="news-grid" *ngIf="newsList2D.length">
    <article class="news-card" *ngFor="let news of newsList2D.flat()">
      <div class="news-card__image">
        <img
          [src]="news.image.fileUUID ? imageBaseUrl + news.image.fileUUID : defaultImg"
          alt="News Image"
        />
      </div>

      <div class="news-card__content">
        <div class="news-card__meta">
          <span>{{ news.category.categoryName }}</span>
          <span>{{ transformDate(news.publicationDate) }}</span>
        </div>

        <h4 class="news-card__title clamp-2">
          {{ news.newsTitle }}
        </h4>

        <div class="news-card__description clamp-3"
             [innerHTML]="news.newsDescp">
        </div>

        <a class="news-card__link" (click)="goToFullNews(news)">
          Read More <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
    </article>
  </section>

</section>
